// useDeviceLayout.ts
import { useMediaQuery, useTheme } from "@mui/material";

export type DeviceLayout = {
  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLandscape: boolean;
};

export function useDeviceLayout(): DeviceLayout {
  const theme = useTheme();

  // Orientation
  const isLandscape = useMediaQuery("(orientation: landscape)");

  // Touch vs mouse-ish
  const isTouch = useMediaQuery("(hover: none) and (pointer: coarse)");

  // Size bands
  const isNarrowWidth  = useMediaQuery("(max-width: 599px)"); // classic phone width
  const isShortHeight  = useMediaQuery("(max-height: 500px)"); // catches phone landscape
  const isMediumWidth  = useMediaQuery(
    "(min-width: 600px) and (max-width: 1199px)"
  ); // typical tablets / small laptops
  const isLargeWidth   = useMediaQuery("(min-width: 1200px)");

  // PHONE:
  // - touch device
  // - either narrow width (portrait) OR very short height (landscape)
  const isPhone = isTouch && (isNarrowWidth || isShortHeight);

  // DESKTOP:
  // - non-touch (mouse/trackpad), OR huge width
  const isDesktop = (!isTouch && isMediumWidth) || isLargeWidth;

  // TABLET:
  // - touch device
  // - not classified as phone
  //   (this will catch iPad portrait & landscape, Android tablets, etc.)
  const isTablet = isTouch && !isPhone;

  return { isPhone, isTablet, isDesktop, isLandscape };
}
